/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad failed to load. Try again later.`)
};

const es_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El anuncio no se pudo cargar. Intenta de nuevo más tarde.`)
};

const de_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werbung konnte nicht geladen werden. Versuche es später erneut.`)
};

const nl_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertentie kon niet worden geladen. Probeer het later opnieuw.`)
};

const fr_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement de la pub. Réessayez plus tard.`)
};

const it_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare la pubblicità. Riprova più tardi.`)
};

const pt_br2_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar anúncio. Tente novamente mais tarde.`)
};

const pt_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar o anúncio. Tente novamente mais tarde.`)
};

const ja_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告の読み込みに失敗しました。後でもう一度お試しください。`)
};

const zh_f1_ad_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告加载失败，请稍后再试。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ad_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ad_error(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ad_error", locale)
	if (locale === "en") return en_f1_ad_error(inputs)
	if (locale === "es") return es_f1_ad_error(inputs)
	if (locale === "de") return de_f1_ad_error(inputs)
	if (locale === "nl") return nl_f1_ad_error(inputs)
	if (locale === "fr") return fr_f1_ad_error(inputs)
	if (locale === "it") return it_f1_ad_error(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ad_error(inputs)
	if (locale === "pt") return pt_f1_ad_error(inputs)
	if (locale === "ja") return ja_f1_ad_error(inputs)
	return zh_f1_ad_error(inputs)
};